import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';

export default class ReportView extends Component {
  static propTypes = {
    report: PropTypes.object.isRequired,
  };

  state = {
    rows: [],
    originalRows: [],
    columns: [],
  };

  componentWillMount = () => {
    const { report } = this.props;
    this.renderColumns(Object.keys(report.get(0)));
    this.renderRows(Object.keys(report.get(0)), report);
  };

  componentWillReceiveProps = nextProps => {
    const { report } = nextProps;
    if (report.size > 0) {
      this.renderColumns(Object.keys(report.get(0)));
      this.renderRows(Object.keys(report.get(0)), report);
    }
  };

  getSize = () => this.getRows().length;

  getRows = () => Data.Selectors.getRows(this.state);

  rowGetter = rowIdx => {
    const rows = this.getRows();
    return rows[rowIdx];
  };

  handleGridSort = (sortColumn, sortDirection) => {
    const { rows, originalRows } = this.state;
    const comparer = (a, b) => {
      if (sortDirection === 'ASC') {
        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else if (sortDirection === 'DESC') {
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      }
      return null;
    };

    const _rows = sortDirection === 'NONE' ? originalRows.slice(0) : rows.sort(comparer);

    this.setState({ rows: _rows });
  };

  renderColumns = columns => {
    const _columns = [];
    columns.map(column => {
      _columns.push({
        key: column,
        name: column.charAt(0).toUpperCase() + column.slice(1),
        resizable: true,
        sortable: column === 'count' || column === 'percentage',
      });
      return _columns;
    });
    return this.setState({ columns: _columns });
  };

  renderRows = (columns, report) => {
    const _rows = [];
    report.map((r, id) => {
      const data = r;
      data.key = id;
      data.id = id;
      columns.forEach(c => {
        if (!data[c]) {
          data[c] = '';
        }
      });
      _rows.push(data);
      return _rows;
    });
    return this.setState({
      rows: _rows,
      originalRows: _rows.slice(),
    });
  };

  render() {
    const { columns } = this.state;
    return (
      <div className="row">
        <div className="col-xs-12">
          <div>
            <ReactDataGrid
              rowKey="key"
              id="key"
              columns={columns}
              onGridSort={this.handleGridSort}
              rowGetter={this.rowGetter}
              rowsCount={this.getSize()}
              minHeight={600}
            />
          </div>
        </div>
      </div>
    );
  }
}
